import {TFunction} from 'i18next'
import {parseBackendError} from '../../utils/parseBackendError.ts'
import {ACTIVATION_ERROR_CONTACT_REQUIRED, ACTIVATION_ERROR_NO_PACK_UNITS} from '../../domain/entities/Activation.ts'

// The contract names the error codes but not where they travel. The API's
// MessageErrorDTO puts them in `errorKey`; `message` is checked too in case the
// code comes back there instead.
export function activationErrorMessage(error: unknown, t: TFunction): string {
    const fallback = t('activation.error.generic')
    const {errorKey, message} = parseBackendError(error, fallback)
    const matches = (code: string) => errorKey === code || message?.includes(code)
    if (matches(ACTIVATION_ERROR_CONTACT_REQUIRED)) return t('activation.error.contactRequired')
    if (matches(ACTIVATION_ERROR_NO_PACK_UNITS)) return t('activation.error.noPackUnits')
    return fallback
}
